import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getEbrouchers = async () => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/getPdf`);

  return response.data;

};
const createEbrouchers = async (formData) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.post(`${base_url}ppp/${id}/addPdf`, formData);

  return response.data;
};
const updateEbroucher = async (News) => {
  const formData = new FormData();
  formData.append("name", News.NewsData.get("name"));
  formData.append("shortName", News.NewsData.get("shortName"));
  formData.append("type", News.NewsData.get("type"));
  formData.append("email", News.NewsData.get("email"));
  formData.append("password", News.NewsData.get("password"));
  formData.append("image", News.NewsData.get("image"));

  const response = await axios.put(
    `${base_url}/ppp/Ebrouchers/editEbroucher/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getEbroucher = async (id) => {
  const response = await axios.get(`${base_url}/ppp/Ebrouchers/getById/${id}`, config);

  return response.data;
};

const deleteEbroucher = async (id) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const idd = User.id;
  const response = await axios.delete(`${base_url}ppp/${idd}/deletepdf/${id}`, config);

  return response.data;
};
const EbroucherService = {
  getEbrouchers,
  createEbrouchers,
  getEbroucher,
  updateEbroucher,
  deleteEbroucher,
};

export default EbroucherService;
